import React, { useState } from 'react';
import Classes from './AddFormPage.module.css';
import { useNavigate } from 'react-router-dom';

const LeftArrow = (props) => (
    <svg xmlns="http://www.w3.org/2000/svg" style={{ flexShrink: '0' }} {...props} viewBox="0 0 448 512" > <path d="M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.2 288 416 288c17.7 0 32-14.3 32-32s-14.3-32-32-32l-306.7 0L214.6 118.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-160 160z" /></svg >
)

const DragIcon = (props) => (
    <svg xmlns="http://www.w3.org/2000/svg" style={{ flexShrink: '0' }} {...props} viewBox="0 0 448 512" > <path d="M128 136c0-22.1-17.9-40-40-40L40 96C17.9 96 0 113.9 0 136l0 48c0 22.1 17.9 40 40 40l48 0c22.1 0 40-17.9 40-40l0-48zm0 192c0-22.1-17.9-40-40-40l-48 0c-22.1 0-40 17.9-40 40l0 48c0 22.1 17.9 40 40 40l48 0c22.1 0 40-17.9 40-40l0-48zm32-192l0 48c0 22.1 17.9 40 40 40l48 0c22.1 0 40-17.9 40-40l0-48c0-22.1-17.9-40-40-40l-48 0c-22.1 0-40 17.9-40 40zM288 328c0-22.1-17.9-40-40-40l-48 0c-22.1 0-40 17.9-40 40l0 48c0 22.1 17.9 40 40 40l48 0c22.1 0 40-17.9 40-40l0-48zm32-192l0 48c0 22.1 17.9 40 40 40l48 0c22.1 0 40-17.9 40-40l0-48c0-22.1-17.9-40-40-40l-48 0c-22.1 0-40 17.9-40 40zM448 328c0-22.1-17.9-40-40-40l-48 0c-22.1 0-40 17.9-40 40l0 48c0 22.1 17.9 40 40 40l48 0c22.1 0 40-17.9 40-40l0-48z" /></svg >
)

const DeleteIcon = (props) => (
    <svg xmlns="http://www.w3.org/2000/svg" style={{ flexShrink: '0' }} {...props} viewBox="0 0 448 512" > <path d="M135.2 17.7L128 32 32 32C14.3 32 0 46.3 0 64S14.3 96 32 96l384 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-96 0-7.2-14.3C307.4 6.8 296.3 0 284.2 0L163.8 0c-12.1 0-23.2 6.8-28.6 17.7zM416 128L32 128 53.2 467c1.6 25.3 22.6 45 47.9 45l245.8 0c25.3 0 46.3-19.7 47.9-45L416 128z" /></svg >
)

const EditIcon = (props) => (
    <svg xmlns="http://www.w3.org/2000/svg" style={{ flexShrink: '0' }} {...props} viewBox="0 0 512 512" > <path d="M410.3 231l11.3-11.3-33.9-33.9-62.1-62.1L291.7 89.8l-11.3 11.3-22.6 22.6L58.6 322.9c-10.4 10.4-18 23.3-22.2 37.4L1 480.7c-2.5 8.4-.2 17.5 6.1 23.7s15.3 8.5 23.7 6.1l120.3-35.4c14.1-4.2 27-11.8 37.4-22.2L387.7 253.7 410.3 231zM160 399.4l-9.1 22.7c-4 3.1-8.5 5.4-13.3 6.9L59.4 452l23-78.1c1.4-4.9 3.8-9.4 6.9-13.3l22.7-9.1 0 32c0 8.8 7.2 16 16 16l32 0zM362.7 18.7L348.3 33.2 325.7 55.8 314.3 67.1l33.9 33.9 62.1 62.1 33.9 33.9 11.3-11.3 22.6-22.6 14.5-14.5c25-25 25-65.5 0-90.5L453.3 18.7c-25-25-65.5-25-90.5 0zm-47.4 168l-144 144c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l144-144c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z" /></svg >
)

const FieldTypes = {
    TEXT: 'text',
    EMAIL: 'email',
    PASSWORD: 'password',
    NUMBER: 'number',
    TEXTAREA: 'textarea',
    PHONE: 'phone',
    ADDRESS: 'address',
    OPT_IN: 'opt-in'
};

export default function AddFormPage() {
    const navigateTo = useNavigate();
    const [formFields, setFormFields] = useState([]);
    const [editingId, setEditingId] = useState(null);
    const [editLabel, setEditLabel] = useState('');
    const [draggedId, setDraggedId] = useState(null);
    const [dragOverId, setDragOverId] = useState(null);
    const [formName, setFormName] = useState('');

    const handleBackClick = () => navigateTo('/forms');

    const handleDragStart = (e, fieldType, id) => {
        if (id) {
            e.dataTransfer.setData('fieldId', id);
            setDraggedId(id);
        } else {
            e.dataTransfer.setData('fieldType', fieldType);
        }
    };

    const handleDragOver = (e, id) => {
        e.preventDefault();
        setDragOverId(id);
    };

    const handleDrop = (e) => {
        e.preventDefault();
        const fieldType = e.dataTransfer.getData('fieldType');
        const fieldId = e.dataTransfer.getData('fieldId');

        if (fieldType) {
            addFieldToForm(fieldType);
        } else if (fieldId) {
            const targetId = dragOverId || formFields[formFields.length - 1]?.id;
            handleReorder(Number(fieldId), targetId);
        }

        setDraggedId(null);
        setDragOverId(null);
    };

    const addFieldToForm = (type) => {
        const newField = {
            id: Date.now(),
            type,
            label: type.charAt(0).toUpperCase() + type.slice(1),
            placeholder: ''
        };
        setFormFields([...formFields, newField]);
    };

    const handleReorder = (draggedId, targetId) => {
        if (!draggedId || !targetId || draggedId === targetId) return;

        const draggedIndex = formFields.findIndex(f => f.id === draggedId);
        const targetIndex = formFields.findIndex(f => f.id === targetId);

        if (draggedIndex === -1 || targetIndex === -1) return;

        const newFields = [...formFields];
        const [removed] = newFields.splice(draggedIndex, 1);

        // Adjust position based on drag direction
        const adjustedTargetIndex = targetIndex > draggedIndex
            ? targetIndex - 1
            : targetIndex;

        newFields.splice(adjustedTargetIndex, 0, removed);
        setFormFields(newFields);
    };

    const deleteField = (id) => {
        setFormFields(formFields.filter(field => field.id !== id));
    };

    const handleLabelChange = (id, newLabel) => {
        setFormFields(formFields.map(field =>
            field.id === id ? { ...field, label: newLabel } : field
        ));
    };

    const renderInput = (field) => {
        switch (field.type) {
            case FieldTypes.TEXTAREA:
                return <textarea rows="3" className={Classes.inputField} placeholder="Start typing..." style={{ resize: "none" }} name="description" />;
            case FieldTypes.EMAIL:
                return <input type="email" className={Classes.inputField} placeholder={field.placeholder} />;
            case FieldTypes.PASSWORD:
                return <input type="password" className={Classes.inputField} placeholder={field.placeholder} />;
            case FieldTypes.NUMBER:
                return <input type="number" className={Classes.inputField} placeholder={field.placeholder} />;
            case FieldTypes.PHONE:
                return <input type="tel" className={Classes.inputField} placeholder="Enter phone number" />;
            case FieldTypes.ADDRESS:
                return <textarea className={Classes.inputField} placeholder="Enter full address" />;
            case FieldTypes.OPT_IN:
                return <input type="checkbox" className={Classes.inputField} style={{ width: 'auto' }} />;
            default:
                return <input type="text" className={Classes.inputField} placeholder={field.placeholder} />;
        }
    };

    return (
        <div className={Classes.hero}>
            <div className={Classes.header}>
                <button onClick={handleBackClick} className={Classes.backButton}>
                    <LeftArrow height='13px' fill='#969696' />
                    <h5>Forms</h5>
                </button>
            </div>
            <div className={Classes.hero2}>
                <div className={Classes.left}>
                    <h3>Add form</h3>
                    <div className={Classes.flexCol1}>
                        <label className={Classes.label}>Name</label>
                        <input
                            type="text"
                            className={Classes.inputField}
                            placeholder="Intake form"
                            value={formName}
                            onChange={(e) => setFormName(e.target.value)}
                        />
                    </div>
                    <label className={Classes.label}>Fields</label>
                    <div
                        className={Classes.formBody}
                        onDragOver={(e) => handleDragOver(e, null)}
                        onDrop={handleDrop}
                    >
                        {formFields && formFields.length > 0 ?
                            <>
                                {formFields.map((field) => (
                                    <FormField
                                        key={field.id}
                                        field={field}
                                        draggedId={draggedId}
                                        dragOverId={dragOverId}
                                        handleDragStart={handleDragStart}
                                        handleDragOver={handleDragOver}
                                        deleteField={deleteField}
                                        editingId={editingId}
                                        setEditingId={setEditingId}
                                        editLabel={editLabel}
                                        setEditLabel={setEditLabel}
                                        handleLabelChange={handleLabelChange}
                                        renderInput={renderInput}
                                    />
                                ))}
                            </>
                            :
                            <>
                                <div className={Classes.empty} >
                                    <img src='/assets/images/empty.png' />
                                    <h4>No fields yet</h4>
                                    <h5>Click or drag a field on the right to add it to your form...</h5>
                                </div>
                            </>
                        }
                    </div>
                    <div className={Classes.btnCon} >
                        <button className={`${Classes.submitBtn} ${Classes.whiteBtn}`}>
                            <h5>Save form</h5>
                        </button>
                    </div>
                </div>
                <div className={Classes.right}>
                    <div className={Classes.rightSection}>
                        <label className={Classes.label}>Client profile</label>
                        <div className={Classes.flexColGroup}>
                            <FieldComponent
                                type={FieldTypes.TEXT}
                                label="Name"
                                onDragStart={handleDragStart}
                            />
                            <FieldComponent
                                type={FieldTypes.EMAIL}
                                label="Email"
                                onDragStart={handleDragStart}
                            />
                        </div>
                        <div className={Classes.flexColGroup}>
                            <FieldComponent
                                type={FieldTypes.PASSWORD}
                                label="Password"
                                onDragStart={handleDragStart}
                            />
                            <FieldComponent
                                type={FieldTypes.ADDRESS}
                                label="Address"
                                onDragStart={handleDragStart}
                            />
                        </div>
                        <div className={Classes.flexColGroup}>
                            <FieldComponent
                                type={FieldTypes.PHONE}
                                label="Phone"
                                onDragStart={handleDragStart}
                            />
                            <FieldComponent
                                type={FieldTypes.OPT_IN}
                                label="Email Opt-in"
                                onDragStart={handleDragStart}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

const FieldComponent = ({ type, label, onDragStart }) => (
    <div className={Classes.flexCol1}>
        <div
            className={Classes.selectBox}
            draggable
            onDragStart={(e) => onDragStart(e, type)}
        >
            <h5>{label}</h5>
        </div>
    </div>
);

const FormField = ({
    field,
    draggedId,
    dragOverId,
    handleDragStart,
    handleDragOver,
    deleteField,
    editingId,
    setEditingId,
    editLabel,
    setEditLabel,
    handleLabelChange,
    renderInput
}) => {
    const isDragging = draggedId === field.id;
    const isDragOver = dragOverId === field.id;
    const isEditing = editingId === field.id;

    return (
        <div
            className={`${Classes.formField} 
                ${isDragging ? Classes.dragging : ''} 
                ${isDragOver ? Classes.dragOver : ''}`}
        >
            <div className={Classes.fieldHeader}>
                {isEditing ? (
                    <div className='flexAlign10' >
                        <input
                            type="text"
                            value={editLabel}
                            onChange={(e) => setEditLabel(e.target.value)}
                            onBlur={() => {
                                handleLabelChange(field.id, editLabel);
                                setEditingId(null);
                            }}
                            className={Classes.labelInput}
                            autoFocus
                        />
                    </div>
                ) : (
                    <div className='flexAlign10' >

                        <label className={Classes.label} > {field.label} </label>
                        <EditIcon height='15px' fill='black' cursor='pointer'
                            onClick={() => {
                                setEditingId(field.id);
                                setEditLabel(field.label);
                            }}
                        />
                    </div>
                )}
                <div className='flexAlign15' >
                    <div onClick={() => deleteField(field.id)} >
                        <DeleteIcon height='13px' fill='#ff7474' cursor='pointer' />
                    </div>
                    <div className={Classes.dragHandle} draggable
                        onDragStart={(e) => {
                            e.dataTransfer.setData('fieldId', field.id);
                            handleDragStart(e, null, field.id);
                        }}
                        onDragOver={(e) => {
                            e.preventDefault();
                            handleDragOver(e, field.id);
                        }}
                        onDrop={(e) => e.preventDefault()} >
                        <DragIcon height='20px' fill='black' cursor='pointer' />
                    </div>
                </div>
            </div>
            {renderInput(field)}
        </div>
    );
};